import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export interface PreviewWellRolesButtonProps {
  previewWellRoles: boolean;
  onToggle: () => void;
  disabled: boolean;
}

/**
 * A button that toggles between showing well roles and other display layers.
 * The button is disabled when there are no well roles in the plate map.
 */
export default function PreviewWellRolesButton({
  previewWellRoles,
  onToggle,
  disabled,
}: PreviewWellRolesButtonProps): JSX.Element {
  return (
    <Button
      className="u-small-spacing-right"
      disabled={disabled}
      buttonStyle={previewWellRoles ? ButtonStyle.TERTIARY_BLUE_POWDER : ButtonStyle.TERTIARY_GRAY}
      size={ButtonSize.SMALL}
      onClick={onToggle}
      text={`Preview well roles: ${previewWellRoles ? 'On' : 'Off'}`}
      icon={ModelTypeConstants.TEMPLATE_COLLECTION}
    />
  );
}
